import { render, staticRenderFns } from "./calls-handling.vue?vue&type=template&id=6195983f"
import script from "./calls-handling.vue?vue&type=script&lang=js"
export * from "./calls-handling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports